export default {
	state: {
		dadosSimuladorEmprestimo: {}
	},
	getters: {
		"dadosSimuladorEmprestimo": state => state.dadosSimuladorEmprestimo
	},
	mutations: {
		setDadosSimuladorEmprestimo(state, payload) {
			state.dadosSimuladorEmprestimo = payload
		}
	},
	actions: {
		atualizarEstadoDadosSimuladorEmprestimo({ commit }, payload) {
			commit('setDadosSimuladorEmprestimo', payload)
		}
	}
};